import { refinementList, searchBox, pagination, stats, configure } from "instantsearch.js/es/widgets"
import { connectHits } from "instantsearch.js/es/connectors"
import { initIndex, customClearRefinements, refinementCssClasses } from "./Algolia.js"
import { createInsightsMiddleware } from "instantsearch.js/es/middlewares"

const destEls = document.querySelectorAll(
    "[data-destinations]"
)
if (destEls.length) {

    const detailedCards = destEls[0].dataset.detailedCards === "true";
    const stateGroupId = destEls[0].dataset.stateGroupId;
    const filterQuery = stateGroupId ? "recordType:Destination AND stateGroups:" + stateGroupId : "recordType:Destination";
    const siteSearch = initIndex();

    const insightsMiddleware = createInsightsMiddleware({
        insightsClient: window.aa,
        insightsInitParams: {
            useCookie: false
        },
        onEvent: (event, aa) => {
            const { insightsMethod, payload, widgetType, eventType } = event;

            // Send the event to Algolia
            if (insightsMethod) {

                if (eventType === "view") {
                    payload.eventName = 'Item Viewed from Destination Search';
                }
                if (eventType === "click") {
                    payload.eventName = "Item Selected from Destination Search";
                }

                aa(insightsMethod, payload);
            }

        }
    });

    siteSearch.use(insightsMiddleware);

    const renderHits = (renderOptions, isFirstRender) => {
        const { hits, widgetParams } = renderOptions;

        widgetParams.container.innerHTML = `
            <div class="row row-cols-1">
          ${hits
                .map(
                    item => detailedCards ?
                        `
                        <div class="col-lg-4 col-12 mb-3 d-flex align-items-stretch">
                            <div class="card" style="width: 100%">
                                <div class="card-body text-center">
                                    <a href="${item.uri}" target="_blank">
                                        <img src="${item.imageUrl ? item.imageUrl : '/images/placeholder.jpg'}" class="card-img-top p-1" style="object-fit: contain; height: 200px;">
                                    </a>
                                    <h4 class="mt-0">
                                        <a href="${item.uri}" class="text-title" target="_blank">${item.name}</a>
                                    </h4>
                                   
                                    <hr class="bg-dark-lighten my-3">
                              
                                    <p class="card-text d-flex justify-content-between">
                                        <span class="fw-semibold">${item.region ?? ""}</span>
                                        <span>${item.addressState ?? ""}</span>
                                    </p>

                                    <h5 class="card-title">${item.contact ?? ""}</h5>
                                    <p>
                                        <i class="fa-light fa-envelope"></i>
                                        <a href="mailto:${item.email ?? ""}">${item.email ?? ""}</a>
                                    </p>
                                    <p>
                                        <i class="fa-light fa-phone"></i>
                                            <a href="tel:${item.phoneNumber ?? ""}">${item.phoneNumber ?? ""}</a>
                                    </p>
                                    
                                    <hr class="bg-dark-lighten my-3">

                                    <div class="row mt-2">
                                        <div class="col-4">
                                            <p class="text-muted fw-semibold mb-1">Score</p>
                                            <h3 class="my-0 text-muted fw-normal">${item.overAllScore ?? ""}</h3>
                                        </div>
                                        <div class="col-4">
                                            <p class="text-muted fw-semibold mb-1">Facilities</p>
                                            <h3 class="my-0 text-muted fw-normal">${item.facilityCount ?? ""}</h3>
                                        </div>
                                        <div class="col-4">
                                            <p class="text-muted fw-semibold mb-1">Spaces</p>
                                            <h3 class="my-0 text-muted fw-normal">${item.spaceCount ?? ""}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                      </div>`
                      :
                      `
                        <div class="col-lg-6 col-12 mb-3 d-flex align-items-stretch">
                            <div class="card" style="width: 100%">
                                <div class="card-body text-center">
                                    <a href="${item.uri}" target="_blank">
                                        <img src="${item.imageUrl ? item.imageUrl : '/images/placeholder.jpg'}" class="card-img-top p-1" style="object-fit: contain; height: 200px;">
                                    </a>
                                    <h4 class="mt-0">
                                        <a href="${item.uri}" class="text-title" target="_blank">${item.name}</a>
                                    </h4>
                                   
                                    <hr class="bg-dark-lighten my-3">
                              
                                    <p class="card-text d-flex justify-content-between">
                                        <span class="fw-semibold">${item.region ?? ""}</span>
                                        <span>${item.addressState ?? ""}</span>
                                    </p>
                                </div>
                            </div>
                      </div>`
                )
                .join("")}
            </div>
                </div>
      `;
    };
    const customHits = connectHits(
        renderHits
    );

    const clearRefinementsEl = document.querySelector("#clear-refinements");

    if(clearRefinementsEl){
        siteSearch.addWidgets(
            [
                customClearRefinements({
                    container: clearRefinementsEl
                }),
    
                searchBox({
                    container: "#searchbox",
                    showReset: false,
                    cssClasses: {
                        form: "input-group",
                        input: "form-control",
                        submit: "btn btn-icon",
                        reset: "btn btn-icon"
                    }
                }),
                refinementList({
                    container: document.querySelector("#refinement-accessibility"),
                    attribute: "destinationAccessibility",
                    limit: 20,
                    sortBy: ["name:desc"],
                    cssClasses: refinementCssClasses
                }),
                refinementList({
                    container: document.querySelector("#refinement-region"),
                    attribute: "region",
                    limit: 20,
                    showMore: true,
                    showMoreLimit: 60,
                    sortBy: ["name:asc"],
                    cssClasses: refinementCssClasses
                }),
                refinementList({
                    container: document.querySelector("#refinement-state"),
                    attribute: "addressState",
                    limit: 10,
                    showMore: true,
                    showMoreLimit: 60,
                    sortBy: ["name:asc"],
                    cssClasses: refinementCssClasses
                }),
                refinementList({
                    container: document.querySelector("#refinement-market"),
                    attribute: "marketSize",
                    limit: 10,
                    showMore: true,
                    showMoreLimit: 60,
                    sortBy: ["name:asc"],
                    cssClasses: refinementCssClasses
                }),
            ]
        );
    }

    siteSearch.addWidgets([   
        customHits(
            {
                container: document.querySelector("#hits")
            }
        ),
        pagination({
            container: "#pagination",
            cssClasses: {
                list: "pagination",
                item: "page-item",
                link: "page-link",
                disabledItem: "page-item disabled",
                selectedItem: "page-item active"
            },
        }),
        stats({
            container: "#stats",
        }),
        configure({
            //hitsPerPage: 8,
            enablePersonalization: true,
            filters: filterQuery
        })
    ]);

    siteSearch.start();
}